/* global axios */
import ApiClient from './ApiClient';

class PipelinesAPI extends ApiClient {
  constructor() {
    super('pipelines', { accountScoped: true });
  }

  board(pipelineId, params = {}) {
    return axios.get(`${this.url}/${pipelineId}/board`, { params });
  }

  // Oportunidades de um contato/conversa, agregadas por todos os pipelines.
  // GET .../pipelines/opportunities?contact_id=X (ou ?conversation_id=Y)
  // -> { opportunities: [ { pipeline_id, pipeline_name, stage_id, stage_name,
  //      behavior, probability, conversation_id, conversation_display_id,
  //      value } ] }
  opportunities(params = {}) {
    return axios.get(`${this.url}/opportunities`, { params });
  }

  metrics(pipelineId, params = {}) {
    return axios.get(`${this.url}/${pipelineId}/metrics`, { params });
  }

  moveCard(pipelineId, data) {
    return axios.post(`${this.url}/${pipelineId}/move_card`, data);
  }

  // Define o valor monetário do negócio da conversa no card.
  // body: { conversation_id, value } -> { id, display_id, value }
  updateCard(pipelineId, data) {
    return axios.patch(`${this.url}/${pipelineId}/update_card`, data);
  }

  reorderStages(pipelineId, stageIds) {
    return axios.post(`${this.url}/${pipelineId}/reorder_stages`, {
      stage_ids: stageIds,
    });
  }

  createStage(pipelineId, data) {
    return axios.post(`${this.url}/${pipelineId}/pipeline_stages`, data);
  }

  updateStage(pipelineId, stageId, data) {
    return axios.patch(
      `${this.url}/${pipelineId}/pipeline_stages/${stageId}`,
      data
    );
  }

  deleteStage(pipelineId, stageId) {
    return axios.delete(`${this.url}/${pipelineId}/pipeline_stages/${stageId}`);
  }
}

export default new PipelinesAPI();
